import {
  CancelRounded,
  CheckCircle,
  Info,
  InfoOutlined,
} from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { CompanyData_V2 } from "@rw1/auto-generated-clients";
import { FC } from "react";
import { useLocalization } from "../../../hooks/useLocalization";

export const ValidationStatus: FC<{
  companies?: CompanyData_V2.Company[];
  isError: boolean;
  isSameCompany?: boolean;
}> = ({ companies, isError, isSameCompany }) => {
  const { t } = useLocalization();
  const theme = useTheme();

  let Icon = InfoOutlined;
  let message = t("licenses.validationStatus.typeAndValidate");
  let fontColor = theme.colors.text[1];
  let iconColor = theme.colors.secondary[8];

  if (isSameCompany) {
    Icon = CancelRounded;
    message = companies?.[0]?.friendlyName ?? "";
    fontColor = theme.colors.red;
    iconColor = theme.colors.red;
  } else if (companies && companies.length > 0) {
    Icon = CheckCircle;
    message =
      companies[0]?.friendlyName ?? t("licenses.validationStatus.companyFound");
    fontColor = theme.colors.green;
    iconColor = theme.colors.green;
  } else if (companies?.length === 0 || isError) {
    Icon = Info;
    message = t("licenses.validationStatus.noCompanyFound");
    fontColor = theme.colors.orange;
    iconColor = theme.colors.orange;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Icon sx={{ fontSize: 20, color: iconColor }} />
      <Typography sx={{ fontSize: 12, fontWeight: "500", color: fontColor }}>
        {message}
      </Typography>
    </Box>
  );
};
